export interface BannerMobileLocalizable {
  url: string;
  firstHeader: string;
  header: string;
  body: string;
  culture: string;
}

export const defaultBannerMobileLocalizableData: BannerMobileLocalizable[] = [
	{
		url: "",
		firstHeader: "",
		header: "",
		body: "",
		culture: "tr-TR"
	},
	{
		url: "",
		firstHeader: "",
		header: "",
		body: "",
		culture: "en-US"
	}
];

/* -------------- Operation based interfaces -------------- */

// LIST
export interface BannerMobileListItem {
	bannerId: string;
	displayOrder?: number;
	hasMenu: boolean;
    isActive: boolean;
	firstHeader: string;
	creationDate: string;
}

export interface BannerMobileListApiResponse {
	result: {
		items: BannerMobileListItem[];
	};
	error: string | null;
	isSuccessful: boolean;
}

// GET
export interface BannerMobileDetail {
	bannerId: string;
	imageUrl: string;
	isActive: boolean;
	displayOrder?: number;
	bannerMobileLocalizable: BannerMobileLocalizable[];
}

export interface BannerMobileGetApiResponse {
	result: {
		bannerId: string;
		imageUrl: string;
		isActive: boolean;
		displayOrder?: number;
		bannerMobileLocalizable: BannerMobileLocalizable[];
	}
	error: string | null;
	isSuccessful: boolean;
}

// ORDER
export interface BannerMobileOrderItem {
	bannerId: string;
	displayOrder?: number;
}

// ADD/UPDATE
export interface BannerMobileFormData {
	bannerId?: string;
	image: File | null;
    isActive: boolean;
    bannerMobileLocalizable: BannerMobileLocalizable[];
}

export const defaultBannerMobileFormData: BannerMobileFormData = {
	bannerId: "",
	image: null,
	isActive: false,
	bannerMobileLocalizable: defaultBannerMobileLocalizableData
};

// Page States
export type OperationStatus =
	| { type: "idle" }
	| { type: "loading"; operation: "add" | "fetch" | "update" | "delete" }
	| { type: "error"; operation: string; message: string };

